import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fip-logged-in-layout',
  templateUrl: './logged-in-layout.component.html',
  styleUrls: ['./logged-in-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoggedInLayoutComponent {}
